import { render, staticRenderFns } from "./SettingsDebug.vue?vue&type=template&id=3d05cdd4&scoped=true"
import script from "./SettingsDebug.vue?vue&type=script&lang=js"
export * from "./SettingsDebug.vue?vue&type=script&lang=js"
import style0 from "./SettingsDebug.vue?vue&type=style&index=0&id=3d05cdd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05cdd4",
  null
  
)

export default component.exports